import glam from 'glamorous';
import { Colors, BrandonGrotesque } from 'module/View/Common';

export const ItemCardWrapper = glam.div({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
});

export const LinkBlock = glam.a({
  position: 'absolute',
  display: 'block',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  color: 'white',
  cursor: 'pointer',
  ':hover': {
    color: 'white',
  },
});

export const DescriptionUnder = glam.div<{ opacity: number }>(p => ({
  color: Colors.black,
  opacity: p.opacity,
  transitionDuration: '0.3s',
}));

export const DescriptionUnderTitle = glam.p({
  marginTop: 0,
  paddingTop: '0.5rem',
  marginBottom: 0,
  fontFamily: BrandonGrotesque.medium,
  fontStyle: 'normal',
  fontWeight: 'normal',
  color: Colors.black,
  fontSize: '1.2rem',
  lineHeight: '1.3',
});

type ImageSizeWrapperProps = { pHeight: number };

export const ImageSizeWrapper = glam.div<ImageSizeWrapperProps>(({ pHeight }) => ({
  position: 'relative',
  display: 'block',
  left: 0,
  right: 0,
  top: 0,
  height: pHeight,
  overflow: 'hidden',
}));

export type AnnimColorCacheProps = { bgColor: string };

export const AnnimColorCache = glam.div<AnnimColorCacheProps>(({ bgColor }) => ({
  position: 'absolute',
  left: -2,
  right: -2,
  top: -2,
  bottom: -2,
  zIndex: 4,
  background: bgColor,
  transform: 'translateY(-100%) translateZ(0px)',
}));

type HoverProps = {
  hover: boolean;
};

const hoverSwitch = <T>(p: HoverProps, notHover: T, hover: T): T => (p.hover ? hover : notHover);
const hoverSwitchFunc = <T>(p: HoverProps, notHover: T, hover: T, render: (v: T) => string): string =>
  render(p.hover ? hover : notHover);

export const Overlay = glam.div<HoverProps>(p => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  zIndex: 2,
  transitionDuration: '0.3s',
  background: hoverSwitchFunc(p, 0, 0.8, a => Colors.darkGrey.alpha(a).toString()),
}));

export const TextOverlay = glam.div({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  zIndex: 3,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: 10,
  textAlign: 'center',
});

export const TextOverlayTitle = glam.h3<HoverProps>(p => ({
  lineHeight: 1.2,
  fontSize: '1.6rem',
  fontFamily: BrandonGrotesque.regular,
  fontStyle: 'normal',
  fontWeight: 'normal',
  transitionDuration: '0.3s',
  transitionDelay: hoverSwitch(p, '0s', '0.3s'),
  opacity: hoverSwitch(p, 0, 1),
  transform: `translateY(${hoverSwitch(p, '-50', '0')}px)`,
}));

export const WaveWrapper = glam.div<HoverProps>(p => ({
  transitionDuration: '0.3s',
  transitionDelay: '0.15s',
  opacity: hoverSwitch(p, 0, 1),
  transform: `translateY(${hoverSwitch(p, '-50', '0')}px)`,
}));

export const CategoriesWrapper = glam.div<HoverProps>(p => ({
  transitionDuration: '0.3s',
  transitionDelay: hoverSwitch(p, '0.3s', '0s'),
  opacity: hoverSwitch(p, 0, 1),
  transform: `translateY(${hoverSwitch(p, '-50', '0')}px)`,
}));

export const TextOverlayCategory = glam.p({
  lineHeight: 1.2,
  marginTop: '0.3rem',
  marginBottom: 0,
});

export const TextOverlayClient = glam.p({
  lineHeight: 1.2,
  marginTop: '0.3rem',
  marginBottom: 0,
  fontFamily: BrandonGrotesque.regularItalic,
  fontStyle: 'normal',
  fontWeight: 'normal',
});



// WEBPACK FOOTER //
// ./src/module/View/ItemCard/ItemCard.s.ts